var $ = jQuery;
const focusableSelector = [
  "a[href]:not([tabindex='-1'])",
  "area[href]:not([tabindex='-1'])",
  "input:not([disabled]):not([tabindex='-1'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
  "iframe:not([tabindex='-1'])",
  "[tabindex]:not([tabindex='-1'])",
  "[contentEditable=true]:not([tabindex='-1'])",
].join(",");

$(document).ready(function(){
  console.log("ready");
  
  $("html").attr("data-page-url", window.location.pathname);
  
  $("body").append(
    '<div class="sr-only live-status-region" role="status"></div>'
  );

  $('.site-header').each((i, header) => {
    const logo = $(header).find('.logo');
    const nav = $(header).find('.nav');
    const mobileMenu = $(header).find('.mobile-menu');
    
    logo.find('img').attr('alt', 'SoSoak Shower & Sitz Bath Chair');
    logo.find('a').removeAttr('aria-label');
    logo.attr('role', 'none');

    const navItems = nav.find('div[data-nav-item]');
    navItems.wrapAll('<ul class="menu__list"></ul>');

    mobileMenu.find('.mobile-menu__button').attr({
      'role': 'button',
      'tabindex': 0
    });

    navItems.each((i, navItem) => {
      $(navItem).attr({
        'role': 'listitem'
      })
    })
  });

  $('.template-index .slideshow .slider-main-header').attr({
    'role': 'heading',
    'aria-level': 2
  });

  $('.footer-title__button').each((i, title) => {
    $(title).removeAttr('aria-expanded').removeAttr('aria-controls');
    
    $(title).attr({
      'role': 'heading',
      'aria-level': 2,
      'tabindex': -1
    })
  });

  $('.newsletter-form').each((i, newsletter) => {
    const title = $(newsletter).find('.footer-title');
    const inputs = $(newsletter).find('.input-group__field');
    const error = $(newsletter).find('.errors');
    const message = $(newsletter).find('.note.form-success');
    const button = $(newsletter).find('.input-group__btn');

    title.attr({
      'role': 'heading',
      'aria-level': 2
    });

    button.on('click', (e) => {
      const input = inputs.first();
      if(input.val()) {
        inputs.first().focus();
      }
    });

    inputs.each((i, input) => {
      let label = $(input).attr('aria-label');
      const id = randomId();

      if(!label) {
        $(input).attr('placeholder')
      }

      const visualLabel = $(`<label class="newsletter-form__label" for="${$(input).attr('id')}">${label} <span class="newsletter-form__label-required">(required)</span></label>`);
      visualLabel.insertBefore($(input).closest('.input-group'));

      if(error.length > 0 && $(input).attr('aria-invalid')) {
        $(input).attr({
          'aria-describedby': id,
        });

        error.attr('id', id);
      };

      $(input).attr('aria-required', true);
      $(input).removeAttr('aria-label');
    });

    error.attr('role', 'alert');
    message.attr('role', 'alert');
  });

  $('.logo--footer div[data-bgset*="files/SoSoak_Badge-Lake.png"]').attr({
    'aria-label': 'Soak Shower & Sitz Bath Chair Cleanse SOS Comfort Calm'
  });

  $('footer .social-sharing-wrapper').each((i, wrapper) => {
    const anchors = $(wrapper).find('a.social-sharing-icon');

    anchors.each((i, anchor) => {
      $(anchor).wrap('<li></li>');
    });

    $(wrapper).attr('role', 'list');
  });

  $('.drawer, .cart-drawer').each((i, drawer) => {
     const observer = new MutationObserver((mutations) => {
         $(drawer).find('.drawer__close-button').attr({
           'aria-expanded': drawer.classList.contains("is-open") 
         })
       
        if (drawer.classList.contains("is-open")) {
          $(drawer).parents().siblings().attr("aria-hidden", "true");
          $(drawer).siblings().attr("aria-hidden", "true");
          
          setTimeout(() => {
            focusFirst(drawer);
          }, 500);
          
        } else {
          $(drawer).parents().siblings().removeAttr("aria-hidden");
          $(drawer).siblings().removeAttr("aria-hidden");
        }
     });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    })
  });

  $('.cart-drawer').each((i, drawer) => {
    const observer = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        for(const node of mutation.addedNodes) {
          if(!node || !node.classList) {
            continue
          };

          if(node.classList.contains('cart-drawer__head')) {
            const heading = $(node).find('h3'); 
            const clone = heading.clone();
            const qty = heading.find('.cart-drawer__item-qty').text();

            clone.find('.cart-drawer__item-qty').remove();
            
            heading.attr({
              'role': 'heading',
              'aria-level': 2,
              'aria-hidden': true
            });

            const hidden = $(`<h2 class="sr-only">${clone.text()} ${qty}</h2>`);

            hidden.insertBefore(heading);

            $(node).find('.cart-drawer__close').attr({
              'role': 'button',
              'tabindex': 0
            })
          }
        }
      }
    });

    observer.observe(drawer, {
      childList: true,
      attributes: true
    })
  });

  $('.template-index .slide__text__container').each((i, container) => {
    const isMobile = window.matchMedia("(max-width: 767px)");
    
    if(!isMobile.matches) {
      return
    };
    
    const info = $(container).find('.slideshow-info');
    const headings = info.children('h3');

    headings.each((i, heading) => {
      $(heading).prepend('<span aria-hidden="true" class="heading-deco-icon"></span>');
    });
    
  });

  $('.accordion__list').each((i, list) => {
    const items = $(list).find('.accordion__item');

    items.each((i, item) => {
      const button = $(item).find('.accordion__item__title');
      const wrapper = $(item).find('.accordion__item__text-wrapper');

      item.removeAttribute('aria-haspopup');

      function handleChange() {
        button.attr('aria-expanded', button.hasClass('is-expanded'));
        wrapper.removeAttr('aria-expanded');
      }

      handleChange();
      
      const observer = new MutationObserver((mutations) => {
        handleChange();
      });

      observer.observe(button.get(0), {
        attributes: true,
        attributeFilter: ['class']
      });

      button.on('click', (e) => {
        if(button.hasClass('is-expanded')) {
          announceToScreenReader('expanded', 'status', 100);
        } else {
          announceToScreenReader('collapsed', 'status', 100);
        }
      });
    });

    $(list).find('a[title^="https://"]').removeAttr('title')
  });

  
  $('.product__accordions').each((i, wrapper) => {
    const accordions = $(wrapper).find('.product__accordion');

    accordions.each((i, accordion) => {
      const button = $(accordion).find('.product__accordion__title');
      const content = $(accordion).find('.product__accordion__content');

      function handleChange() {
        button.attr('aria-expanded', button.hasClass('is-expanded'));
        content.removeAttr('aria-expanded');
      }

      handleChange();
      
      const observer = new MutationObserver((mutations) => {
        handleChange();
      });

      observer.observe(button.get(0), {
        attributes: true,
        attributeFilter: ['class']
      });

      button.on('click', (e) => {
        if(button.hasClass('is-expanded')) {
          announceToScreenReader('expanded', 'status', 100);
        } else {
          announceToScreenReader('collapsed', 'status', 100);
        }
      });
    });
  });

  $('a[href$="www.shopify.com/legal/terms"]:contains("here")').attr('aria-label', 'For term of services click here').removeAttr('title');
  $('a[href$="www.shopify.com/legal/privacy"]:contains("here")').attr('aria-label', 'For privacy policy click here').removeAttr('title');

  $('.product-single__gallery').each((i, gallery) => {
    const slider = $(gallery).find('.product-single__media-slider');
    const thumbs = $(gallery).find('.product-single__thumbnails');

    slider.removeAttr('tabindex');

    function anonounceSlideChange() {
      slides.each(function (index, slide) {
        if (slide.classList.contains("is-selected")) {
          announceToScreenReader(`You are on slide ${index + 1}/${slides.length}`);
          return;
        }
      });
    }

    slider.find('.visually-hidden').attr('aria-hidden', true);

    thumbs.find('.product-single__thumbnail').each((i, thumbnail) => {
      thumbnail.removeAttribute('aria-hidden');

      const button = $(thumbnail).find('.product-single__thumbnail-link');
      
      button.attr({
        'role': 'button',
        'tabindex': 0
      });

      button.on('click', (e) => {
        anonounceSlideChange();
        button.focus();
      });

      const observer = new MutationObserver((mutations) => {
        thumbnail.removeAttribute('aria-hidden');
        if(thumbnail.classList.contains('is-nav-selected')) {
          button.attr('aria-current', true)
        } else {
          button.removeAttr('aria-current');
        }
      });

      observer.observe(thumbnail, {
        'attributes': true,
        'attributeFilter': ['class']
      })
    });

    const slides = $(slider).find('.flickity-slider .product-single__media-slide');

    slides.each((i, slide) => {
      const img = $(slide).find('[data-product-image]');
      const link = $(slide).find('.product-single__media-link');
      
      $(slide).removeAttr('aria-hidden');
      link.append(img);

      link.on('click', (e) => {
        setTimeout(() => {
          $('.pswp .pswp__img:not(.pswp__img--placeholder)').attr({
            'alt': img.attr('alt')
          });
          
          
          console.log($('.pswp'));
        }, 500)
      });
    });

    $(slider).find('.flickity-button').each((i, button) => {
      $(button).on('click', (e) => {
        anonounceSlideChange();
      })
    });
  });

  $('.product-single__wrapper').each((i, wrapper) => {
    function handleChange() {
      $(wrapper).find('iframe').attr({
        'tabindex': -1
      })
    }

    handleChange();
    
    const observer = new MutationObserver((mutations) => {
      handleChange();
    });

    observer.observe(wrapper, {
      childList: true,
      subtree: true
    })
  });

  $('.pswp').each((i, pswp) => {
    const container = pswp.querySelector('.pswp__container');
    const left = $(pswp).find('.pswp__button--arrow--left'); 
    const right = $(pswp).find('.pswp__button--arrow--right');

    left.add(right).on('click', (e) => {
      announceToScreenReader('Slide Changed')
    })

    if(!container) {
      return
    }

    const observer = new MutationObserver((mutations) => {
      const images = $(pswp).find('.pswp__img:not(.pswp__img--placeholder)');

      images.each((i, image) => {
        const src = `${image.getAttribute('src')}`;
        const file = src.split('?')[0].split('/').at(-1);
        const alt = $(`.product-single__media-link[href*="${file}"] img`).attr('alt');

        image.setAttribute('alt', alt);
      });
      
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['style']
    });
    
  });

  $('[data-page-url="/products/sosoak-shower-soaking-chair"] iframe#_pericles_content_iframe').attr('aria-hidden','true');

  $(':root[data-page-url="/pages/about-us"] .image-with-text__heading.h2').attr({
    'role': 'heading',
    'aria-level': 2
  });

  $(".social-sharing-icon.facebook img").attr('alt','Facebook');
  $(".social-sharing-icon.instagram img").attr('alt','Instagram');
  $("#Email--footer-block-3").attr('autocomplete','email');

  // $('iframe#_pericles_content_iframe').attr('title','');
  $("img[src*='/SoSoak_Tagline-Pearl']").attr("alt","Cleanse Comfort Calm");
  $('img[src*="ChairHero_33a5fba2-05b2-49b6-b471-99cf3b741038.png"]').attr("alt", "");

  $('input[name="contact[first-name]"]').attr('autocomplete','given-name');
  $('input[name="contact[last-name]"]').attr('autocomplete','family-name');
  $('input[name="contact[email]"]').attr('autocomplete','email');


  $('#ContactForm').each((i, form) => {
    const textInfo = $(form).find("div.text-info");
    const message = $(form).find('.note.form-success');
    
    $(form).find('label').append(`<span aria-hidden="true">*</span>`);
    $(`<p class="a11y_custom">* is indicating required fields</p>`).insertAfter(textInfo);

    message.attr('role', 'alert');
  });

  $('.blog .blog__post').each((i, post) => {
    const title = $(post).find('.blog__post-title');

    title.attr({
      'role': 'heading',
      'aria-level': 2
    });
  });

  $('.background-size-cover[data-bgset*="Social.jpg"], img[data-srcset*="Social_180x.jpg"]').attr('aria-label', 'SoSoak, SHOWER & SITZ BATH CHAIR');
  $('img[data-srcset*="Social_180x.jpg"]').attr('alt', 'SoSoak, SHOWER & SITZ BATH CHAIR');
  
  $('.article__image').each((i, img) => {
    const observer = new MutationObserver((mutations) => {
      const srcset = img.getAttribute('srcset');

      if(!srcset) {
        return
      }

      if(srcset.includes('Social_180x.jpg')) {
        $(img).attr('alt', 'SoSoak, SHOWER & SITZ BATH CHAIR'); 
      }
    });


    observer.observe(img, {
      attributes: true,
      attributeFilter: ['srcset', 'data-srcset', 'class']
    })
  });

  $('.share-link').each((i, share) => {
    const tooltip = $(share).siblings('.tooltip-default');

    function handleChange() {
      if(tooltip.hasClass('is-visible')) {
        tooltip.removeAttr('aria-hidden');
        tooltip.attr('role', 'alert');
      } else {
        tooltip.attr('aria-hidden', true);
        tooltip.removeAttr('role');
      }
    }

    handleChange();

    const observer = new MutationObserver((mutations) => {
      handleChange();
    });

    observer.observe(tooltip.get(0), {
      attributes: true,
      attributeFilter: ['class']
    })
  });

  $(':root[data-page-url$="/pages/terms-of-use"]').each((i, page) => {
    $(page).find('.rte > strong').attr({
      'role': 'heading',
      'aria-level': 2
    })
  });

  $('.template-index .slider').each((i, slider) => {
    console.log($(slider).find('.background-size-cover'));
    
    slider.removeAttribute('tabindex');
    $(slider).find('img[src*="files/SoSoak_Tagline-Pearl.png"]').attr('alt', 'Cleanse. Comfort. Calm');
    $(slider).find('.slide__image').removeAttr('aria-label');
    $(slider).find('.background-size-cover').removeAttr('role').removeAttr('alt').removeAttr('aria-label');
  });

  $(':root[data-page-url$="/pages/about-us"] .slider, .template-product .slider').each((i, slider) => {
    slider.removeAttribute('tabindex');
    $(slider).find('img[src*="files/SoSoak_Tagline-Pearl.png"]').attr('alt', 'Cleanse. Comfort. Calm');
    $(slider).find('.background-size-cover').removeAttr('role').removeAttr('alt').removeAttr('aria-label');
  });

  $('#Text--template--18502966444343__466599ab-918c-417b-ae15-7ab0b9de7225-16800359396d5e9680-1 h2, #Text--template--18502966673719__a8deeeca-1c1e-4f44-b144-bd5ee317b057-16807861520b67a875-1 h2').each((i, h2) => {
    $(h2).attr({
      'role': 'none'
    });

    $(h2).wrap(`<blockquote class="homepage__testimonial-heading"></blockquote>`);
  })

  $('.footer-links__wrapper').each((i, footer) => {
    $(footer).removeAttr('id');
  });  

  $(`:root[data-page-url="/pages/faqs"] .page-title`).each((i, el) => {
    const clone = $(el).clone();
    clone.text($(el).text().toLowerCase());

    clone.addClass("sr-only");

    $(clone).insertBefore(el);

    $(el).attr({
      "aria-hidden": true,
    });
  });

  $(`:root[data-page-url="/pages/faqs"] title`).each((i, title) => {
    const text = $(title).text().toLowerCase();
    $(title).text(text);
  });

  $(`:root[data-page-url*="/products/"]`).each((i, page) => {
    const meta = $(page).find('meta[property="og:site_name"]');
    const name = meta.attr('content');
    const title = $(page).find('title');
    const titleText = title.text();

    title.text(`${titleText} - ${name}`)
  })
});

$(window).on("load", function () {
  
  $(':root[data-page-url="/pages/privacy-policy"]').each((i, page) => {
    $(page).find('.rte > h1').attr({
      'role': 'heading',
      'aria-level': 2
    });

    const observer = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        for(const node of mutation.addedNodes) {
          if(node.classList.contains('table-wrapper')) {
            const wrapper = $(node);
            const table = wrapper.find('table');
            const title = wrapper.prev('h2');

            table.prepend(`<caption class="sr-only">${title.text().trim()}</caption>`);

            $(table).find("thead, tbody, tfoot, tr, th, td").attr("role", function () {
              if ($(this).is("table")) {
                return "table";
              } else if ($(this).is("thead")) {
                return "rowgroup";
              } else if ($(this).is("tbody")) {
                return "rowgroup";
              } else if ($(this).is("tfoot")) {
                return "rowgroup";
              } else if ($(this).is("tr")) {
                return "row";
              } else if ($(this).is("th")) {
                return "columnheader";
              } else if ($(this).is("td")) {
                return "cell";
              }
            });
          }
        }
      }
    });

    observer.observe(page, {
      childList: true,
      subtree: true
    });
  });
});

function randomId(length = 10) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

function focusFirst(element) {
  const $ = jQuery;
  const focusableElements = $(element).find(focusableSelector);

  focusableElements.first().focus();
}

let liveElementTimeout = null;
  
function announceToScreenReader(text, role, timeout = 1000, once = false) {
  if (once && liveElementTimeout) {
    return;
  }

  const liveElement = document.querySelector(".live-status-region");
  const paraElement = document.createElement("p");
  const textElement = document.createTextNode(text);

  if (!liveElement) {
    return;
  }

  liveElement.setAttribute("role", role === undefined ? "status" : role);
  paraElement.appendChild(textElement);
  liveElement.appendChild(paraElement);

  liveElementTimeout = setTimeout(() => {
    liveElement.innerHTML = "";
    liveElement.setAttribute("role", "status");
  }, timeout);
}